import { render, staticRenderFns } from "./OrderCommercialCard.vue?vue&type=template&id=81cb3ab4"
import script from "./OrderCommercialCard.vue?vue&type=script&lang=js"
export * from "./OrderCommercialCard.vue?vue&type=script&lang=js"
import style0 from "./OrderCommercialCard.vue?vue&type=style&index=0&id=81cb3ab4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports